import React from 'react';

const Arrow = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.40024 13L8.30024 17.9C8.50024 18.1 8.59608 18.3334 8.58774 18.6C8.57941 18.8667 8.47524 19.1 8.27524 19.3C8.07524 19.4834 7.84191 19.5792 7.57524 19.5875C7.30858 19.5959 7.07524 19.5 6.87524 19.3L0.275244 12.7C0.175244 12.6 0.104411 12.4917 0.0627441 12.375C0.0210775 12.2584 0.000244141 12.1334 0.000244141 12C0.000244141 11.8667 0.0210775 11.7417 0.0627441 11.625C0.104411 11.5084 0.175244 11.4 0.275244 11.3L6.87524 4.70005C7.05858 4.51672 7.28774 4.42505 7.56274 4.42505C7.83774 4.42505 8.07524 4.51672 8.27524 4.70005C8.47524 4.90005 8.57524 5.13755 8.57524 5.41255C8.57524 5.68755 8.47524 5.92505 8.27524 6.12505L3.40024 11H14.5752C14.8586 11 15.0961 11.0959 15.2877 11.2875C15.4794 11.4792 15.5752 11.7167 15.5752 12C15.5752 12.2834 15.4794 12.5209 15.2877 12.7125C15.0961 12.9042 14.8586 13 14.5752 13H3.40024Z"
        fill="#1D222A"
      />
    </svg>
  );
};

export default Arrow;
